import { Grid } from '@mui/material'
import { SeccionDocumentacion } from '../components/SeccionDocumentacion'
import { useOperacion } from '../hooks/useOperacion'

export const Documentacion = () => {

    const { idOperacion, codSistemaPrincipal, codSistemaTipo: codSistema } = useOperacion()

    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <SeccionDocumentacion
                    idPais={codSistemaPrincipal}
                    idOperacion={idOperacion}
                    codSistema={codSistema}
                />
            </Grid>
        </Grid>
    )
}
